import React, { Component } from 'react';
import { Api } from '../../api/api-routes';
import { connect } from 'react-redux';
import { showErrorAlert, showSuccessAlert } from '../../redux/actions/alert';
import { addBgImage, removeBgImage } from '../../redux/actions/bg-image';
import Button from 'react-bootstrap/Button';

class ChooseBgButton extends Component {

    postImage = (event) => {
        const formData = new FormData();
        formData.append('file', event.target.files[0]);
        formData.append('type', 'background');

        Api.saveImage(formData)
            .then(res => {
                if (res.status === 'success') {
                    this.props.addBgImage(res.url);
                    this.props.updateBackgroundId(res.id);
                } else {
                    this.props.showErrorAlert(res.errorMessage);
                }
            })
            .catch(e => {
                this.props.showErrorAlert(e.message);
            })
    };

    removeBgImage = () => {
        this.props.removeBgImage();
        this.props.updateBackgroundId('');
    };

    render() {
        return (
            <>
                <div className="back-picture-picker">
                    <label className="input-item-name">Choose a background image
                        <input
                            onChange={this.postImage}
                            type="file"
                            id="back-image"
                            name="file"
                            accept="image/png, image/jpeg"
                        />
                    </label>
                </div>
                {
                    this.props.bgImage &&
                    <Button
                        variant="light"
                        onClick={this.removeBgImage}
                    >
                        <span>Remove image</span>
                        <i
                            style={{ marginLeft: '10px' }}
                            color="red"
                            className="fa fa-trash"
                            aria-hidden="true"
                        />
                    </Button>
                }
            </>
        );
    }
}

export default connect(
    state => ({
        bgImage: state.bgImage,
    }),
    {
        showErrorAlert,
        showSuccessAlert,
        addBgImage,
        removeBgImage
    }
)(ChooseBgButton);




